/*
 * Created by anthony on 7/8/14.
 */
var schoolModel = angular.module('schoolModel', ['authService']);
schoolModel.factory('SchoolModelFactory', function(ApplicationService, BaseModel, $cookieStore){
    var SchoolModelFactory = function(endpoint){
        BaseModel.apply(this, arguments);
    }

    SchoolModelFactory.prototype = new BaseModel();  
    SchoolModelFactory.prototype.parent = BaseModel.prototype;
    SchoolModelFactory.prototype.getSchoolID = function()
    {
        return $cookieStore.get('auth').schoolID;
    }
    SchoolModelFactory.prototype.getEndpoint = function(schoolID)
    {
        if (typeof schoolID == 'undefined')
            schoolID = this.getSchoolID();
        if (typeof this.endpoint == 'undefined')
            return "/api/school/" + schoolID;
        return "/api/school/" + schoolID + this.endpoint;
    }
    SchoolModelFactory.prototype.setIndex = function(item, index)
    {
        if (typeof this.dataProperty === 'undefined')
        {
            this.data[index] = angular.copy(item);
            this.origData[index] = angular.copy(item);
        }
        else
        {
            this.data[this.dataProperty][index] = angular.copy(item);
            this.origData[this.dataProperty][index] = angular.copy(item);
        }
    }
    SchoolModelFactory.prototype.isDirty = function()
    {
        let oldData = this.get();
        let newData = this.data;
        return !equalsTypeless(newData, oldData);
    }

    /**
     * Custom implementation of angular.equals that does not do typed comparisons on primitives
     *
     * equalsTypeless(24, "24"); // returns true
     *
     * @param {any} o1 
     * @param {any} o2 
     * @returns {boolean} true if objects are equal
     */
    function equalsTypeless(o1, o2) {
        if (o1 == o2) return true;
        if (o1 === null || o2 === null) return false;
        if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
        var t1 = typeof o1, length, key, keySet;
        if (t1 == 'object') {
            if (angular.isArray(o1)) {
                if (!angular.isArray(o2)) return false;
                if ((length = o1.length) == o2.length) {
                for (key = 0; key < length; key++) {
                    if (!equalsTypeless(o1[key], o2[key])) return false;
                }
                return true;
                }
            } else if (angular.isDate(o1)) {
                if (!angular.isDate(o2)) return false;
                return equalsTypeless(o1.getTime(), o2.getTime());
            } else {
                if (angular.isArray(o2) || angular.isDate(o2)) return false;
                keySet = {};
                for (key in o1) {
                    if (key.charAt(0) === '$' || angular.isFunction(o1[key])) continue;
                    if (!equalsTypeless(o1[key], o2[key])) return false;
                    keySet[key] = true;
                }
                for (key in o2) {
                    if (!keySet.hasOwnProperty(key) &&
                        key.charAt(0) !== '$' &&
                        o1[key] !== undefined &&
                        o2[key] !== undefined &&
                        !angular.isFunction(o2[key])) return false;
                }
                return true;
            }
        }
        return false;
    }

    return SchoolModelFactory;
});

schoolModel.service('SchoolModelService', function(SchoolModelFactory){
    var schoolModel = new SchoolModelFactory();
    return schoolModel;

});